import m from "mithril";

const LOGO = "https://www.hamajima.co.jp/assets/svg/logo.svg";

class SimpleHeader {
  view(vnode) {
    return m("header#l-header-simple", {
      class: vnode.attrs.class,
    }, [
      m(".header-head[data-fixed]", [
        m("h1.head-ttl", vnode.children),
        m(".head-logo", [
          m("a[href=#]", [
            m("img[alt=浜島書店ロゴ]", {src: LOGO}),
          ]),
        ]),
      ]),
    ]);
  }
}

class SimpleFooter {
  view(vnode) {
    return m("footer#l-footer.simple", {
      class: vnode.attrs.class,
    }, [
      m(".footer-lower", [
        m(".lower-inner[data-fixed]", 
          m("p.lower-copy", "Copyright © Hamajima Shoten, Publishers. All rights reserved."),
        ),
      ]),
    ]);
  }
}

class MainLContent {
  view(vnode) {
    return m("main#l-content", {
      class: vnode.attrs.class,
    }, [
      m(".content-inner[data-fixed]", vnode.children),
    ]);
  }
}

class H2View {
  view(vnode) {
    return m("h2.m-txt-ttl2", {
      class: vnode.attrs.class,
      id: vnode.attrs.id,
    }, vnode.children);
  }
}

class H3View {
  view(vnode) {
    return m("h3.m-txt-ttl3", {
      class: vnode.attrs.class,
      id: vnode.attrs.id,
    }, vnode.children);
  }
}

class H4View {
  view(vnode) {
    return m("h4.m-txt-ttl4", {
      class: vnode.attrs.class,
      id: vnode.attrs.id,
    }, vnode.children);
  }
}

class ParagraphView {
  view(vnode) {
    return m("p.m-txt-p", {
      id: vnode.attrs.id,
      class: vnode.attrs.class,
    }, vnode.children);
  }
}

class BoxFrameView {
  view(vnode) {
    return m(".m-box-frame", {
      class: vnode.attrs.class,
      id: vnode.attrs.id,
    }, vnode.children);
  }
}

class FrameTitleView {
  view(vnode) {
    return m("p.m-txt-frame-ttl", {
      class: vnode.attrs.class,
      id: vnode.attrs.id,
    }, vnode.children);
  }
}

class PrimaryBoxFrameView {
  view(vnode) {
    return m(BoxFrameView, {class: "frame-primary"}, vnode.children);
  }
}

class SecondaryBoxFrameView {
  view(vnode) {
    return m(BoxFrameView, {class: "frame-secondary"}, vnode.children);
  }
}

class TextInputView {
  view(vnode) {
    return m("input[type=text].m-form-txt", {
      id: vnode.attrs.id,
      class: vnode.attrs.class,
      size: vnode.attrs.size,
      placeholder: vnode.attrs.placeholder,
      oninput: vnode.attrs.oninput,
      onchange: vnode.attrs.onchange,
      value: vnode.attrs.value,
    });
  }
}

class RadioButtonsView {
  view(vnode) {
    return m("ul.m-form-radio", {
      class: vnode.attrs.class,
      id: vnode.attrs.id,
    }, [
      vnode.attrs.items.map(item => {
        return m("li.radio-item", [
          m("label", [
            m("input[type=radio]", {
              name: vnode.attrs.name,
              value: item.value,
              checked: item.checked,
              disabled: vnode.attrs.disabled,
              onclick: e => {
                if(vnode.attrs.onclick) {
                  vnode.attrs.onclick(item, e.target.checked);
                }
              },
            }),
            m("span", item.label),
          ]),
        ]);
      }),
    ])
  }
}
class CheckBoxesView {
  view(vnode) {
    return m("ul.m-form-check", {
      class: vnode.attrs.class,
      id: vnode.attrs.id,
    }, [
      vnode.attrs.items.map(item => {
        return m("li.check-item", [
          m("label", [
            m("input[type=checkbox]", {
              name: vnode.attrs.name,
              value: item.value,
              checked: item.checked,
              disabled: vnode.attrs.disabled,
              onclick: e => {
                if(vnode.attrs.onclick) {
                  vnode.attrs.onclick(item, e.target.checked);
                }
              },
            }),
            m("span", item.label),
          ])
        ]);
      })
    ]);
  }
}

class SelectView {
  view(vnode) {
    return m(".m-form-select", {
      class: vnode.attrs.class,
      id: vnode.attrs.id,
    }, [
      m("select", {
        name: vnode.attrs.name,
        disabled: vnode.attrs.disabled,
        onchange: vnode.attrs.onchange,
      }, [
        vnode.attrs.items.map(item => {
          return m("option", {
            value: item.value,
            selected: item.selected,
          }, item.label);
        })
      ])
    ])
  }
}

class CommonBtnView {
  view(vnode) {
    return m("button[type=button].m-btn-common", {
      id: vnode.attrs.id,
      class: vnode.attrs.class,
      disabled: vnode.attrs.disabled,
      onclick: vnode.attrs.onclick,
    }, vnode.children);
  }
}

class SimpleBtnView {
  view(vnode) {
    return m("button[type=button].m-btn-simple", {
      id: vnode.attrs.id,
      class: vnode.attrs.class,
      disabled: vnode.attrs.disabled,
      onclick: vnode.attrs.onclick,
    }, vnode.children);
  }
}

class BackBtnView {
  view(vnode) {
    return m(m.route.Link, {
      href: vnode.attrs.href ? vnode.attrs.href : "#",
      id: vnode.attrs.id,
      class: "m-btn-simple btn-back btn-size-s nav-back",
      onclick: vnode.attrs.href ? null : e => {history.back();},
    }, m("span", "戻る"));
  }
}

export {
  SimpleHeader, SimpleFooter, MainLContent, H2View, H3View, H4View, ParagraphView, BoxFrameView, FrameTitleView, PrimaryBoxFrameView, SecondaryBoxFrameView,
  RadioButtonsView, CheckBoxesView, SelectView, TextInputView, CommonBtnView, SimpleBtnView, BackBtnView,
};